import {
  FieldHelperText,
  FieldProps,
  LabelWithIconAndTooltip,
  getIconForProperty,
  useModeController,
} from "@firecms/core";
import MDEditor from "@uiw/react-md-editor";

/**
 * Markdown editor with a toolbar and live preview. Used instead of FireCMS's
 * built-in `markdown: true` field, which hides formatting behind a slash menu.
 */
export function MarkdownField({
  propertyKey,
  value,
  setValue,
  error,
  showError,
  property,
  includeDescription,
  disabled,
  isSubmitting,
}: FieldProps<string>) {
  const { mode } = useModeController();

  return (
    <>
      <LabelWithIconAndTooltip
        propertyKey={propertyKey}
        icon={getIconForProperty(property, "small")}
        required={property.validation?.required}
        title={property.name}
        className="h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
      />

      {/* Follows the CMS light/dark mode. */}
      <div data-color-mode={mode}>
        <MDEditor
          value={value ?? ""}
          // Empty reports undefined; store null so `required` catches it.
          onChange={(next) => setValue(next ? next : null)}
          height={560}
          preview="live"
          visibleDragbar
          textareaProps={{
            placeholder: "Write the post here…",
            disabled: disabled || isSubmitting,
          }}
        />
      </div>

      <FieldHelperText
        includeDescription={includeDescription}
        showError={showError}
        error={error}
        disabled={disabled}
        property={property}
      />
    </>
  );
}
